import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import initDepartments from "../modules/departments.js";
import { initCarousels } from "../modules/product-collection";
import "../../scss/home.scss";
import { sendRTBHomePageViewEvent } from "../modules/analytics/rtb-house";
import { Consent } from "@fruugo/utilities";
import { initPromotions } from "../modules/promotions";
import initHomeBanner from "../modules/home-banner";

function initPageSpecificAnalytics() {
  sendRTBHomePageViewEvent();
}

function onConsentUpdate() {
  document.addEventListener("consentUpdate", (e: Event) => {
    const customEvent = e as CustomEvent<{ consents: Consent }>;
    const consents = customEvent.detail.consents;
    if (consents && consents.advertising) {
      sendRTBHomePageViewEvent();
    }
  });
}

async function initHomePage() {
  await initTranslation();
  initHomeBanner();
  initDepartments();
  initPage();
  initCarousels();
  initPageSpecificAnalytics();
  initPromotions();
  onConsentUpdate();
}

initHomePage();
